/**
 * Cookie Helper Functions
 *
 * Client-side cookie utilities for setting and getting cookies
 */

export const BANNER_COOKIE_NAME = 'banner-closed';

/**
 * Set a session cookie (expires when browser closes)
 */
export function setSessionCookie(name: string, value: string): void {
    if (typeof document === 'undefined') return;

    // Session cookie (no max-age/expires = deleted when browser closes)
    document.cookie = `${name}=${value}; path=/; SameSite=Lax`;
}

/**
 * Get cookie value by name (client-side)
 */
export function getCookie(name: string): string | null {
    if (typeof document === 'undefined') return null;

    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
        // An empty cookie value ("name=") is treated as absent → null. `??` would
        // instead return the empty string, so `||` is intentional here.
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- '' must map to null
        return parts.pop()?.split(';').shift() || null;
    }

    return null;
}
